import { Fragment } from 'react';
import clsx from 'clsx';
import * as prismicH from '@prismicio/helpers';

import { linkResolver } from '../prismicio';
import { Tentative } from '../components/Tentative';
import { showDatePeriodDay } from '../lib/date_helpers';

const ProjectCalendarList = ({ projects, hideName }) => (
  <table>
    {projects.map((project) => (
      <Fragment key={project.id}>
        {hideName || (
          <thead>
            <tr>
              <th colSpan="2" className="pt-3">
                <a href={linkResolver(project)}>
                  {prismicH.asText(project.data.title)}
                </a>
              </th>
            </tr>
          </thead>
        )}
        <tbody>
          {project.data.timeline_items.map((item) => (
            <tr key={item.title}>
              <td className={clsx(item.tentative && 'text-muted')}>
                {item.start_date ? (
                  <>
                    {showDatePeriodDay(item.start_date, item.end_date)}
                    {item.tentative && (
                      <Tentative className="text-small ms-1" />
                    )}
                  </>
                ) : (
                  <Tentative />
                )}
              </td>
              <td
                className={clsx(
                  'ps-3',
                  item.tentative && !item.start_date && 'text-muted'
                )}>
                {item.title}
              </td>
            </tr>
          ))}
        </tbody>
      </Fragment>
    ))}
  </table>
);

export default ProjectCalendarList;
